import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Store, ArrowRight } from "lucide-react";
import { useAuth } from "../lib/auth";
import { InlineNotice } from "../components/ui";

export function SignupPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    storeName: "",
    businessType: "Tạp hóa",
    ownerName: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await auth.signup(form);
      navigate("/");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Không thể tạo tài khoản");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card auth-card-wide">
        <div className="auth-brand">
          <img src="/logo.png" alt="BLedger" />
          <div>
            <h1>Tạo tài khoản bằng Email</h1>
            <p>Tạo tài khoản chủ cửa hàng bằng email. Sau này có thể đăng nhập Google bằng cùng địa chỉ email đã xác minh.</p>
          </div>
        </div>

        {error ? <InlineNotice tone="danger" title={error} /> : null}

        <form onSubmit={submit} className="form-grid">
          <label>
            Tên cửa hàng / Hộ kinh doanh
            <input
              placeholder="VD: Tạp hóa Cô Ba, Siêu thị Mini An Lạc"
              value={form.storeName}
              onChange={(e) => setForm({ ...form, storeName: e.target.value })}
              required
            />
          </label>
          <label>
            Loại hình kinh doanh
            <select
              value={form.businessType}
              onChange={(e) => setForm({ ...form, businessType: e.target.value })}
            >
              <option>Tạp hóa</option>
              <option>Thực phẩm & Đồ uống</option>
              <option>Mini mart</option>
              <option>Bán lẻ tổng hợp</option>
              <option>Mỹ phẩm & Hóa mỹ phẩm</option>
              <option>Khác</option>
            </select>
          </label>
          <label>
            Họ và tên chủ cửa hàng
            <input
              placeholder="VD: Nguyễn Văn A"
              value={form.ownerName}
              onChange={(e) => setForm({ ...form, ownerName: e.target.value })}
              required
            />
          </label>
          <label>
            Email đăng nhập
            <input
              type="email"
              placeholder="ten@cuahang.com"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
            />
          </label>
          <label className="form-span">
            Mật khẩu
            <input
              type="password"
              minLength={10}
              placeholder="Ít nhất 10 ký tự bảo mật"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              required
            />
          </label>

          <button className="btn btn-primary btn-lg form-span" disabled={busy}>
            <Store size={20} />
            {busy ? "Đang tạo tài khoản..." : "Tạo tài khoản bằng Email"}
            <ArrowRight size={18} />
          </button>
        </form>

        <div className="auth-links">
          <span>Đã có tài khoản? </span>
          <Link to="/login">Đăng nhập</Link>
        </div>
      </div>
    </div>
  );
}
